import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiOptionItem, APIResponse } from '../interfaces/api.interface';
import { SampleSuite, SampleSuiteSearchParams } from '../interfaces/option.interface';
import { queryParamString } from '../utils/query-param-string';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class OptionService {
  public constructor(private readonly api: ApiService) {}

  public getSampleSuites(
    organisationId: string,
    params?: SampleSuiteSearchParams,
  ): Observable<APIResponse<SampleSuite[]>> {
    return this.api.get<APIResponse<SampleSuite[]>>(
      queryParamString(`organisations/${organisationId}/options/suites`, params),
    );
  }

  public getSampleTypes(
    organisationId: string,
  ): Observable<APIResponse<string[]>> {
    return this.api.get<APIResponse<string[]>>(
      `organisations/${organisationId}/options/types`,
    );
  }

  public getSampleMatrices(
    organisationId: string,
  ): Observable<APIResponse<ApiOptionItem[]>> {
    return this.api.get<APIResponse<ApiOptionItem[]>>(
      `organisations/${organisationId}/options/matrices`,
    );
  }
}
